/**
 * TD Customization — Legacy page content compatibility layer
 * Date: 2026-02-13
 * Reason: Hydrate 2025 lazyload markup (data-src/data-srcset) inside 2026 page content containers.
 */

const LEGACY_CONTAINER_SELECTOR = '.td-page-anwendung__content, .td-page-about__content, .td-page-benefits-summary__content, .td-page-stress__content, .td-page-autism__content, .td-page-anxiety__content, .td-page-dementia__content, .td-page-adhs-add__content, .td-page-wohlbefinden__content, .td-page-schlafstorungen__content, .td-page-testimonial-single__content, .td-legacy-page-content';
const LEGACY_MEDIA_SELECTOR = 'img[data-src], img[data-srcset], source[data-srcset]';

function hydrateLegacyMedia(root = document) {
  const scope = root instanceof Element || root instanceof Document ? root : document;
  const legacyNodes = scope.querySelectorAll(`${LEGACY_CONTAINER_SELECTOR} ${LEGACY_MEDIA_SELECTOR}`);

  legacyNodes.forEach((node) => {
    const dataSrc = node.getAttribute('data-src');
    const dataSrcset = node.getAttribute('data-srcset');

    if (dataSrc) {
      node.setAttribute('src', dataSrc);
      node.removeAttribute('data-src');
    }

    if (dataSrcset) {
      node.setAttribute('srcset', dataSrcset);
      node.removeAttribute('data-srcset');
    }

    if (node.tagName === 'IMG') {
      node.classList.remove('lazyload', 'Image--lazyLoad', 'ls-is-cached');

      if (!node.hasAttribute('loading')) {
        node.setAttribute('loading', 'lazy');
      }
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => hydrateLegacyMedia());
} else {
  hydrateLegacyMedia();
}

document.addEventListener('shopify:section:load', (event) => {
  hydrateLegacyMedia(event.target);
});

document.addEventListener('shopify:section:select', (event) => {
  hydrateLegacyMedia(event.target);
});
